<template>
  <div class="edit">
    <mu-dialog title="编辑客户" width="500" :open="open" @close="close">
      <mu-form :model="editForm" label-position="left" label-width="80">
        <!-- <mu-form-item prop="userName" label="用户名">
          <mu-text-field v-model="editForm.userName"></mu-text-field>
        </mu-form-item> -->

        <mu-form-item prop="realName" label="真实姓名">
          <mu-text-field v-model.trim="editForm.realName"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="company" label="公司">
          <mu-text-field v-model.trim="editForm.company"></mu-text-field>
        </mu-form-item>

        <!-- <mu-form-item prop="type" label="用户类型">
          <mu-radio value="员工" v-model="editForm.type" label="员工"></mu-radio>
          <mu-radio value="客户" v-model="editForm.type" label="客户"></mu-radio>
          <mu-radio value="管理员" v-model="editForm.type" label="管理员"></mu-radio>
        </mu-form-item> -->

        <mu-form-item prop="phone" label="手机号">
          <mu-text-field v-model.number="editForm.phone"></mu-text-field>
        </mu-form-item>

        <!-- <mu-form-item prop="role" label="角色">
          <mu-select v-model="editForm.role.id" @change="roleChange">
            <mu-option v-for="(item,index) in roleList" :key="index" :label="item.name" :value="item.id"></mu-option>
          </mu-select>
        </mu-form-item> -->
      </mu-form>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
      <mu-button slot="actions" color="primary" @click="submit">提交</mu-button>
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    },
    form: {
      type: Object
    }
  },
  data() {
    return {
      editForm: {
        role: {
          id: 0
        }
      },
      roleList: []
    }
  },
  methods: {
    submit() {
      backend(api.user.update, this.editForm).then((result) => {
        if (result.statusCode === 200) {
          this.close()
          this.$emit('finish')
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    },
    getAllRole() {
      backend(api.role.getAll, { getAll: true }).then((res) => {
        if (res.statusCode === 200) {
          this.roleList = res.data.rows
        }
      })
    },
    roleChange(roleId) {
      this.editForm.role = this.roleList.find((x) => x.id === roleId)
    }
  },
  watch: {
    open(val) {
      if (val) {
        this.editForm = JSON.parse(JSON.stringify(this.form))
      }
    }
  },
  mounted() {
    // this.getAllRole()
  }
}
</script>

<style lang="less" scoped>
.edit {
}
</style>



// WEBPACK FOOTER //
// src/views/customer/update.vue